import Cookies from 'js-cookie';

export default class checkCookie{
    
    /**
     * Cookie exist
     * @returns 
     */
    cookieExist() {
    
        const getCookie = Cookies.get('supay_comments');
        
        if(typeof getCookie == 'undefined'){

            return false;

        }

        return true;
    
    }

}